export const getServiceChargePercentageError = (
  enabled: boolean,
  percentage: number
) => {
  if (!enabled) return undefined;

  return Number.isFinite(percentage) && percentage > 0 && percentage <= 100
    ? undefined
    : 'El porcentaje debe ser mayor que 0 y no puede superar 100.';
};
